var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[_c('div',{staticClass:"customer-tracking-indicator",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"color":"black","size":"18"}},[_vm._v("fa-star")])],1),_vm._v(" "),_c('span',[_vm._v("Seguimiento creado")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b32a227","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/CustomerTrackingIndicator.vue
// module id = null
// module chunks = 